<template>
  <div id="bridge-cable" class="h-full p-10px w-full">
    <div class="w-full flex justify-between items-center mb-10px">
      <el-input v-model="keyword" class="!w-[calc(100%-80px)] mr-10px" placeholder="请输入关键词">
      </el-input>
      <el-button @click="getTree">搜索</el-button>
    </div>
    <el-tree
      :props="treeProps"
      :data="treeData"
      :default-checked-keys="defaultCheckedKeys"
      show-checkbox
      node-key="id"
      @node-click="clickModelTree"
      @check="checkChange"
      class="h-[calc(100%-50px)] overflow-y-auto overflow-x-hidden !bg-transparent"
    >
    </el-tree>
  </div>
</template>
<script>
import { CableTrayApi } from '@wiz-api/tongre'
import { isJSONObj } from '../../../assets/js/scene/scene.js'
import HandoverService from '../../../service/HandoverService'

const cableTrayApi = new CableTrayApi()

export default {
  name: 'bridgeCable',
  props: {
    /** 场景id */
    sourceId: {
      type: String,
      defalut: '',
    },
    player: {
      type: Object,
      defalut: () => {
        return {}
      },
    },
    cloudRender: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      keyword: '',
      treeProps: {
        label: 'name',
        children: 'childrens',
        isLeaf: 'leaf',
      },
      treeData: [],
      defaultCheckedKeys: [],
      standardId: '',
    }
  },
  methods: {
    async loadNode(node, resolve) {
      console.log(node, '树-----------', this.cloudRender)
      if (node.level === 0) {
        const [err, res] = await cableTrayApi.getCableTrayTree({ sceneId: this.sourceId })
        if (!err) {
          res.forEach((e) => {
            e.checked = true
          })
          this.defaultCheckedKeys = res.map((o) => {
            return o.id
          })
          resolve(res)
        }
        return
      }
      if (node.data.childrens && node.data.childrens?.length !== 0) {
        this.defaultCheckedKeys.push(
          ...node.data.childrens.map((o) => {
            return o.id
          })
        )
        return resolve(node.data.childrens)
      }
      let item = null
      if (!node.data.item) {
        item = node.data.code
          ? await this.player.Native.ModelTree.findItemByCode(node.data.code)
          : await this.player.Native.ModelTree.findItemByName(node.data.name, 0, true, 3)
      }
      const res = await this.player.Native?.ModelTree.getSubItems(node.data.item || item?.item)

      const filterRes = _.filter(res, (el) => {
        el.id = el.item
        return el?.name && el?.visible
      })
      _.forEach(filterRes, async (el) => {
        if (
          isJSONObj(node.data.code) &&
          (JSON.parse(node.data.code).type === 'Root' ||
            JSON.parse(node.data.code).type === 'userData') &&
          el.itemType === 0 &&
          el.nodePtr
        ) {
          const nodeInfo = await this.player.Native.NodeProxy.getNodeInfo(el.nodePtr)
          if (nodeInfo.name) {
            el.name = nodeInfo.name
          }
          el.code = nodeInfo.code
        }
        if (node.checked) {
          this.defaultCheckedKeys.push(el.id)
        }
      })
      resolve(filterRes)
    },

    async getTree() {
      const [err, res] = await cableTrayApi.getCableTrayTree({
        sceneId: this.sourceId,
        keyWords: this.keyword,
      })
      if (!err) {
        res.forEach((e) => {
          e.checked = true
        })
        this.defaultCheckedKeys = res.map((o) => {
          return o.id
        })

        this.treeData = res
        res.forEach(async (e) => {
          const item = e.code
            ? await this.player.Native.ModelTree.findItemByCode(e.code)
            : await this.player.Native.ModelTree.findItemByName(e.name, 0, true, 3)
          e.item = item.item
          this.player.Native.ModelTree.setItemVisible(item.item, true)
        })
      }
    },
    async clickModelTree(data) {
      const { eye, target, up } = JSON.parse(data.angle)
      this.player.Native.Camera.moveTo(eye, target, up, 2)
      if (!data.item) {
        const item = data.code
          ? await this.player.Native.ModelTree.findItemByCode(data.code)
          : await this.player.Native.ModelTree.findItemByName(data.name, 0, true, 3)
        data.item = item.item

        this.player.Native.ModelTree.setSelectItem(item.item)
      } else {
        this.player.Native.ModelTree.setSelectItem(data.item)
      }
      const [err, res] = await HandoverService.getInfo({
        code: data.code,
        standardId: this.standardId,
      })
      this.$emit('transferEvent', {
        toCom: { code: 'ObjectInfoDyw', origin: 'HandoverObjectDyw', name: '对象信息' },
        type: 'business',
        props: data.code
          ? {
              ...res.data[0],
              standardId: this.standardId,
              openAlarmFlicker: true,
              flickerFrequency: 500,
            }
          : {
              standardId: this.standardId,
              openAlarmFlicker: true,
              flickerFrequency: 500,
              code: data.code,
            },
      })
    },
    async checkChange(data, { checkedKeys }) {
      if (!data.item) {
        const item = data.code
          ? await this.player.Native.ModelTree.findItemByCode(data.code)
          : await this.player.Native.ModelTree.findItemByName(data.name, 0, true, 3)
        data.item = item.item
      }
      await this.player.Native.ModelTree.setItemVisible(data.item, checkedKeys.includes(data.id))
    },
    async getStandardList() {
      const [err, res] = await HandoverService.getStandardList()
      if (!err && res && res.code === 0 && res.data) {
        this.standardId = res.data[0].id
      } else {
        this.standardId = ''
      }
    },
  },
  async created() {
    const roots = await this.player.Native.ModelTree.getRootItems()
    await this.player.Native.ModelTree.setItemVisible(
      roots.map((o) => {
        return o.item
      }),
      false
    )

    this.getTree()
    await this.getStandardList()
  },
  async beforeDestroy() {
    const roots = await this.player.Native.ModelTree.getRootItems()
    await this.player.Native.ModelTree.setItemVisible(
      roots.map((o) => {
        return o.item
      }),
      true
    )
    this.player.Native.ModelTree.setSelectItem(0)
  },
}
</script>

<style lang="scss" scoped>
#bridge-cable {
  background-color: transparent;
  ::v-deep .el-button {
    color: #fff !important;
  }
}
</style>
